if ($(window).width() < 640) {    
    $(".insights .insights-cards .insights-cards-item").each(function () {
        $(this).click(function(e){
            $(this).toggleClass("active").siblings().removeClass("active");
        });
    });
}